export default __webpack_public_path__ + "static/media/circle-right.5d6c8c33.svg";